import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React, { Component } from "react";
import { Button, Title, Header } from "../Header";
import YearsList from "./YearsList";
var YearPicker = /*#__PURE__*/function (_Component) {
  _inherits(YearPicker, _Component);
  var _super = _createSuper(YearPicker);
  function YearPicker() {
    var _this;
    _classCallCheck(this, YearPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      selectedYear: _this.props.selectedYear ? parseInt(_this.props.selectedYear, 10) : new Date().getFullYear()
    };
    _this.increaseYear = function () {
      _this.setState({
        selectedYear: _this.state.selectedYear + 16
      });
    };
    _this.decreaseYear = function () {
      _this.setState({
        selectedYear: _this.state.selectedYear - 16
      });
    };
    return _this;
  }
  _createClass(YearPicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var selectedYear = this.state.selectedYear;
      var chooseYear = this.props.chooseYear;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
        "data-test": "yearsHeader"
      }, /*#__PURE__*/React.createElement(Button, {
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.decreaseYear();
        },
        direction: "backward"
      }), /*#__PURE__*/React.createElement(Title, {
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onClick: function onClick() {
          return chooseYear(_this2.props.selectedYear);
        }
      }, this.props.selectedYear), /*#__PURE__*/React.createElement(Button, {
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onMouseUp: function onMouseUp(e) {
          return e.preventDefault();
        },
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.increaseYear();
        },
        direction: "forward"
      })), /*#__PURE__*/React.createElement(YearsList, {
        chooseYear: chooseYear,
        selectedYear: selectedYear
      }));
    }
  }]);
  return YearPicker;
}(Component);
export default YearPicker;